/* eslint-disable no-unused-expressions */
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { logError } from '@log';
import {
  addSelectedItems, clearSelectedItems, deleteSelectedItems, addPackageReason,
} from '@store/slices/claimSlice';
import { useState } from 'react';
import { ClaimType } from '@constants';
import { useBehaviorData } from '@hooks';

export const usePackageCheckbox = () => {
  const {
    fulfilledItems, unFulfilledItems, orderName, type, selectedItems, returnCoverageDay,
  } = useSelector((state) => state.claim);
  const { reasonList, platform } = useSelector((state) => state.policy);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const setReportData = useBehaviorData();

  const [open, setOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [reason, setReason] = useState({});
  const [willChecked, setWillChecked] = useState({
    willCheckedValue: '',
    packageIndex: 0,
    lineIndex: 0,
    willCheckedItem: {},
  });
  const isContinueBtnDisable = selectedItems.length === 0;

  const onClickContinue = async () => {
    try {
      setReportData({ chooseItemsTime: `${Date.now()}`, issueType: type });

      setIsLoading(true);
      // 皆需要选择打款方式
      navigate('../payment');
    } catch (error) {
      logError(error);
    }
  };

  const handleOK = (reason) => {
    setOpen(false);
    dispatch(addSelectedItems(willChecked.willCheckedValue));
    dispatch(addPackageReason({ willChecked, reason }));
  };

  // lineItem 勾选change
  const handleChange = (event, packageIndex, lineIndex, item) => {
    const { checked, value } = event.target || {};
    if (!checked) {
      dispatch(deleteSelectedItems(value));
    } else if (type === ClaimType.RA && !item.reason) {
      setOpen(true);
      setReason({ reason: item.reason, comment: item.comment, files: item.attachments });
      setWillChecked({
        willCheckedValue: value, packageIndex, lineIndex, willCheckedItem: item,
      });
    } else {
      dispatch(addSelectedItems(value));
    }
  };

  // reason-dialog edit click
  const handleItemEdit = (item, packageIndex, lineIndex) => {
    setOpen(true);
    setReason({ reason: item.reason, comment: item.comment, files: item.attachments });
    setWillChecked({
      ...willChecked, packageIndex, lineIndex,
    });
  };

  const clearItems = () => {
    dispatch(clearSelectedItems());
  };
  return {
    platform,
    fulfilledItems,
    returnCoverageDay,
    unFulfilledItems,
    orderName,
    type,
    isContinueBtnDisable,
    selectedItems,
    open,
    reason,
    reasonList,
    isLoading,
    willChecked,
    onClickContinue,
    handleChange,
    clearItems,
    handleClose: () => setOpen(false),
    handleOK,
    handleItemEdit,
  };
};
